(function($) {

    var membershipFormValid1 = true;
    var membershipFormValid2 = true;
    var membershipFormValid3 = true;
    var membershipFormNextStep1 = $('.membership-form-next-step1');
    var membershipFormNextStep2 = $('.membership-form-next-step2');
    var membershipFormSubmit = $('.membership-form-submit');
    var membershipRequiredFields1 = $('.membership-form-wrap1 .required');
    var membershipRequiredFields2 = $('.membership-form-wrap2 .required');
    var membershipRequiredFields3 = $('.membership-form-wrap3 .required');

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    $(document).ready(function() {
        var languagesDropdown = $('.membership-languages-dropdown').select2({
            minimumResultsForSearch: Infinity,
            placeholder: $(this).data('placeholder')
        });

        languagesDropdown.on('select2:opening select2:closing', function( event ) {
            var $searchfield = $(this).parent().find('.select2-search__field');
            $searchfield.prop('disabled', true);
        });
    });

    $('.membership-form-previous-step1').on('click', function () {
        $('.content-switcher .content-switch').removeClass('active');
        $('.content-switcher .content-switch[data-tab=1]').addClass('active');

        $('.content-tab').removeClass('active');
        $('.content-tab-1').addClass('active');

        $('html, body').animate({scrollTop: 0}, 400);
    });

    $('.membership-form-previous-step2').on('click', function () {
        $('.content-switcher .content-switch').removeClass('active');
        $('.content-switcher .content-switch[data-tab=2]').addClass('active');

        $('.content-tab').removeClass('active');
        $('.content-tab-2').addClass('active');

        $('html, body').animate({scrollTop: 0}, 400);
    });

    membershipFormNextStep1.on('click', function() {
        membershipFormValid1 = true;
        $('.membership-form-wrap1 .input-wrap').removeClass('has-error');
        $('.membership-form-wrap1 .input-wrap .input-error').hide();
        $('#membership-agree').parent().removeClass('has-error');

        membershipRequiredFields1.each(function (ind, val) {
            if ($(val).val() === '') {
                membershipFormValid1 = false;
                $(val).parent().addClass('has-error').find('.input-error.error-required').show();
            } else if ($(val).attr('name') === 'membership-code') {
                if ($(val).val().length !== 11) {
                    membershipFormValid1 = false;
                    $(val).parent().addClass('has-error').find('.input-error.error-invalid').show();
                }
            } else if ($(val).attr('name') === 'membership-email') {
                if (!validateEmail($(val).val())) {
                    membershipFormValid1 = false;
                    $(val).parent().addClass('has-error').find('.input-error.error-invalid').show();
                }
            }

            if (!$('#membership-agree').is(':checked')) {
                membershipFormValid1 = false;
                $('#membership-agree').parent().addClass('has-error');
            }
        });

        if (membershipFormValid1) {
            membershipFormSubmit.addClass('loading');

            // var conv = 0;
            // if ($('[name=membership-conviction]').is(':checked')) {
            //     conv = 1;
            // }

            var data = {
                'action' : 'submit_membership',
                'name': $('[name=membership-name]').val(),
                'surname': $('[name=membership-surname]').val(),
                'email': $('[name=membership-email]').val(),
                'phone': $('[name=membership-phone]').val(),
                'department': $('[name=membership-department]').val(),
                'workplace': $('[name=membership-workplace]').val(),
            };

            $.get(postmpwp.ajax_url, data, function(response){
                if (response.success) {
                    $('.membership-content').hide();
                    $('.supporter-status').show();

                    $('html, body').animate({scrollTop: 0}, 400);
                }
            });
        } else {
            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }

        // if (membershipFormValid1) {
        //     $('.content-switcher .content-switch').removeClass('active');
        //     $('.content-switcher .content-switch[data-tab=2]').addClass('active');
        //
        //     $('.content-tab').removeClass('active');
        //     $('.content-tab-2').addClass('active');
        //
        //     $('html, body').animate({scrollTop: 0}, 400);
        // } else {
        //     $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        // }
    });

    membershipFormNextStep2.on('click', function() {
        membershipFormValid2 = true;
        $('.membership-form-wrap2 .input-wrap').removeClass('has-error');
        $('.membership-form-wrap2 .input-wrap .input-error').hide();

        membershipRequiredFields2.each(function (ind, val) {
            if ($(val).val() === '') {
                membershipFormValid2 = false;
                $(val).parent().addClass('has-error').find('.input-error.error-required').show();
            }
        });

        if (membershipFormValid2) {
            $('.content-switcher .content-switch').removeClass('active');
            $('.content-switcher .content-switch[data-tab=3]').addClass('active');

            $('.content-tab').removeClass('active');
            $('.content-tab-3').addClass('active');

            $('html, body').animate({scrollTop: 0}, 400);
        } else {
            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }
    });

    membershipFormSubmit.on('click', function () {
        membershipFormValid3 = true;
        $('.membership-form-wrap3 .input-wrap').removeClass('has-error');
        $('.membership-form-wrap3 .input-wrap .input-error').hide();
        $('#membership-agree3').parent().removeClass('has-error');

        membershipRequiredFields3.each(function (ind, val) {
            if ($(val).val() === null) {
                membershipFormValid3 = false;
                $(val).parent().addClass('has-error').find('.input-error.error-required').show();
            }

            if (!$('#membership-agree3').is(':checked')) {
                membershipFormValid3 = false;
                $('#membership-agree3').parent().addClass('has-error');
            }
        });

        if (membershipFormValid3) {
            membershipFormSubmit.addClass('loading');

            var conv = 0;
            if ($('[name=membership-conviction]').is(':checked')) {
                conv = 1;
            }

            var data = {
                'action' : 'submit_membership',
                'name': $('[name=membership-name]').val(),
                'surname': $('[name=membership-surname]').val(),
                'email': $('[name=membership-email]').val(),
                'phone': $('[name=membership-phone]').val(),
                'address': $('[name=membership-address]').val(),
                'department': $('[name=membership-department]').val(),
                'workplace': $('[name=membership-workplace]').val(),
                'code': $('[name=membership-code]').val(),
                'education': $('[name=membership-education]').val(),
                'school': $('[name=membership-school]').val(),
                'degree': $('[name=membership-degree]').val(),
                'languages': $('[name="membership-languages[]"]').val(),
                'org': $('[name=membership-org]').val(),
                'contacts': $('[name=membership-contacts]').val(),
                'conviction': conv,
                'work': $('[name="membership-work[]"]').val(),
                'events': $('[name="membership-events[]"]').val(),
                'recomendations': $('[name=membership-recomendations]').val(),
            };

            $.get(postmpwp.ajax_url, data, function(response){
                if (response.success) {
                    $('.membership-content').hide();
                    $('.supporter-status').show();

                    $('html, body').animate({scrollTop: 0}, 400);
                }
            });
        } else {
            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }

    });

})( jQuery );